import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'

const publicApi = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' })
const states = {
  active: ['อยู่ในช่วงอายุสัญญา', '#166534', '#dcfce7'],
  scheduled: ['กำหนดวันสิ้นสุดก่อนกำหนดแล้ว', '#92400e', '#fef3c7'],
  not_started: ['ยังไม่ถึงวันเริ่มสัญญา', '#1e40af', '#dbeafe'],
  terminated: ['สิ้นสุดสัญญาก่อนกำหนดแล้ว', '#991b1b', '#fee2e2'],
  expired: ['ครบกำหนดสิ้นสุดสัญญาแล้ว', '#991b1b', '#fee2e2'],
  cancelled: ['ยกเลิกสัญญาแล้ว', '#991b1b', '#fee2e2'],
  rejected: ['สัญญาไม่ผ่านการอนุมัติ', '#991b1b', '#fee2e2'],
  not_signed: ['ยังลงนามไม่ครบถ้วน', '#92400e', '#fef3c7']
}
const dateLabel = value => {
  if (!value) return '-'
  return new Date(`${value}T00:00:00Z`).toLocaleDateString('th-TH', {
    timeZone: 'UTC', day: 'numeric', month: 'long', year: 'numeric'
  })
}

export default function VerifyPage() {
  const { year, number } = useParams()
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(true)
  const [reload, setReload] = useState(0)
  useEffect(() => {
    const controller = new AbortController()
    setLoading(true)
    publicApi.get(`/contracts/verify/${encodeURIComponent(year)}/${encodeURIComponent(number)}`, {
      signal: controller.signal
    }).then(res => setResult(res.data)).catch(err => {
      if (controller.signal.aborted) return
      setResult({ success: false, message: err.response?.status === 404
        ? 'ไม่พบสัญญานี้ในระบบ' : 'ไม่สามารถตรวจสอบได้ในขณะนี้ กรุณาลองอีกครั้ง' })
    }).finally(() => { if (!controller.signal.aborted) setLoading(false) })
    return () => controller.abort()
  }, [year, number, reload])
  const data = result?.success ? result.data : null
  const [label, color, background] = states[data?.current_state] || ['ยังไม่สามารถยืนยันสถานะได้', '#475569', '#f1f5f9']
  const stopped = ['terminated', 'expired', 'cancelled', 'rejected'].includes(data?.current_state)
  const effectiveLabels = { terminated: 'วันที่สิ้นสุดก่อนกำหนด', expired: 'วันสิ้นสุดตามสัญญา', scheduled: 'วันที่กำหนดสิ้นสุด', not_started: 'วันเริ่มสัญญา' }
  return (
    <main className="public-form-page verify-public-page" style={{ minHeight: '100vh', background: '#f3f8ff', padding: '24px 16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <section style={{ background: '#fff', width: '100%', maxWidth: '540px', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 36px rgba(30,64,175,.12)' }}>
        <header style={{ background: '#e0f2fe', padding: '24px', color: '#0c4a6e' }}>
          <h1 style={{ fontSize: '22px', fontWeight: 700 }}>ตรวจสอบสัญญาจ้าง</h1>
          <p style={{ marginTop: '6px' }}>เทศบาลนครมาบตาพุด</p>
        </header>
        <div style={{ padding: '24px' }} aria-live="polite">
          {loading ? <p>กำลังตรวจสอบสถานะล่าสุด...</p> : !data ? <p role="alert">{result?.message || 'ไม่พบข้อมูลสัญญา'}</p> : <>
            <div style={{ padding: '16px', borderRadius: '12px', color, background, border: `1px solid ${color}`, marginBottom: '20px' }}>
              <p style={{ fontSize: '13px' }}>สถานะปัจจุบันของสัญญา</p>
              <strong style={{ fontSize: '20px', display: 'block', marginTop: '6px' }}>{label}</strong>
              {data.effective_date && <p style={{ marginTop: '8px' }}>{effectiveLabels[data.current_state] || 'วันที่มีผล'}: {dateLabel(data.effective_date)}</p>}
              {stopped && <p style={{ marginTop: '8px' }}>เอกสารเดิมยังเป็นหลักฐานย้อนหลัง กรุณาติดต่อเทศบาลก่อนใช้เพื่อยืนยันการจ้างปัจจุบัน</p>}
            </div>
            <dl style={{ margin: 0 }}>
              {[
                ['เลขสัญญา', data.display_contract_no || data.contract_no],
                ['การลงนาม', data.signing_complete ? 'ลงนามครบถ้วนแล้ว' : 'ยังลงนามไม่ครบถ้วน'],
                ['วันที่ลงนามครบ', dateLabel(data.mayor_signed_date)],
                ['ชื่อพนักงาน (ปกปิดบางส่วน)', data.employee_name_masked],
                ['ตำแหน่ง', data.position], ['ประเภทพนักงาน', data.emp_type], ['กองงาน', data.division_name],
                ['วันเริ่มตามสัญญา', dateLabel(data.start_date)], ['วันสิ้นสุดตามสัญญา', dateLabel(data.end_date)]
              ].map(([key, value]) => <div key={key} style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 16px', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #e2e8f0' }}>
                <dt style={{ color: '#475569' }}>{key}</dt><dd style={{ margin: 0, fontWeight: 600, overflowWrap: 'anywhere' }}>{value || '-'}</dd>
              </div>)}
            </dl>
            <div style={{ background: '#eff6ff', padding: '16px', borderRadius: '12px', marginTop: '20px', lineHeight: 1.6 }}>
              <strong>ก่อนใช้เอกสาร</strong>
              <p>เทียบเลขสัญญา วันที่ ตำแหน่ง และเลขหน้ากับเอกสารที่ได้รับ ตรวจสอบว่าเว็บไซต์นี้เป็นโดเมนของเทศบาล</p>
              <p style={{ marginTop: '8px' }}>QR นี้แสดงข้อมูลและสถานะในระบบ ไม่ได้ยืนยันว่าข้อความทั้งหมดบนกระดาษหรือไฟล์ PDF ไม่ถูกแก้ไข หากต้องการตรวจเนื้อหาฉบับเต็ม กรุณาติดต่อเจ้าหน้าที่เทศบาล</p>
            </div>
            <p style={{ fontSize: '12px', color: '#64748b', marginTop: '16px' }}>ตรวจสอบเมื่อ {new Date(data.checked_at).toLocaleString('th-TH', { timeZone: 'Asia/Bangkok' })} (เวลาประเทศไทย)</p>
          </>}
          {!loading && <button type="button" onClick={() => setReload(v => v + 1)} style={{ marginTop: '16px', padding: '10px 16px', borderRadius: '8px', border: '1px solid #93c5fd', background: '#eff6ff', color: '#1e40af', cursor: 'pointer' }}>ตรวจสอบสถานะอีกครั้ง</button>}
        </div>
      </section>
    </main>
  )
}
